/* eslint-disable no-unused-vars */
import React, { useState } from "react";
import ForgotPasswordModal from "../../PopUpModal/ForgotPasswordModal";
import { handleForgotPassword } from "../../../firebaseFunctions/forgotPassword/forgotPassword";
import {
  getAuth,
  updatePassword,
  EmailAuthProvider,
  reauthenticateWithCredential,
} from "firebase/auth";
import { useAuth } from "../../../context/AuthContext";
import { app } from "../../../firebaseFunctions/config";
import PopUpModal from "../../PopUpModal/PopUpModal";
import ModalComponent from "../../MPS/EventRegistration/EventsModal";
import ModalLoadingState from "../../PopUpModal/ModalLoadingState";
import { CheckCircleIcon as CheckCircleIconSolid } from "@heroicons/react/solid";
import alert from "../../../assets/images/alert-circle.svg";
import Button from "../../ui/Button";
import { deleteMPSBusinessProfile } from "../../../firebaseFunctions/deleteMPSprofile";

const AccountSettingsContent = ({ userSignInMethod }) => {
  const [currentPassword, setCurrentPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmNewPassword, setConfirmNewPassword] = useState("");
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");
  const [isForgotPasswordModalOpen, setIsForgotPasswordModalOpen] = useState(false);
  const [email, setEmail] = useState("");
  const { user } = useAuth();
  const userID = user.uid;
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [popUpModalType, setPopUpModalType] = useState(null)
  const [isLoading, setIsLoading] = useState(false);
  const { signOut } = useAuth();

  const openForgotPasswordModal = () => {
    if (!isGoogleSignIn) {
      setIsForgotPasswordModalOpen(true);
    }
  };

  const handleChangePassword = async (e) => {
    e.preventDefault();
    setError("");
    setSuccess("");

    if (newPassword !== confirmNewPassword) {
      setError("New passwords do not match.");
      return;
    }

    try {
      const auth = getAuth(app);
      const credential = EmailAuthProvider.credential(
        user.email,
        currentPassword
      );
      await reauthenticateWithCredential(user, credential);
      await updatePassword(user, newPassword);
      setSuccess("Password changed successfully.");
      setCurrentPassword("");
      setNewPassword("");
      setConfirmNewPassword("");
    } catch (error) {
      setError(
        "Failed to change password. Please check your current password."
      );
    }
  };
  const closeForgotPasswordModal = () => {
    setEmail("");
    setIsForgotPasswordModalOpen(false);
  };

  const handleDeleteClick = () => {
    setIsModalOpen(true);
    setPopUpModalType("delete account");
  }
  const handleDeleteAccount = async () => {
    setIsLoading(true);
    try {
      const result = await deleteMPSBusinessProfile(userID);

      if (result) {
        setPopUpModalType("delete success")
      } else {
        setPopUpModalType("delete failure")
      }
    } catch (error) {
      console.error("Error deleting account:", error);
    } finally {
      setIsLoading(false);
    }
  };
  const handleReturnToLogin = () => {
    signOut()
  }
  const isGoogleSignIn = userSignInMethod === "Google";

  const renderModal = () => {
    switch (popUpModalType) {
      case "delete account":
        return (
          <ModalComponent
            title="Delete Account"
            message="You are about to delete your pebble account. This action cannot be undone."
            checkboxLabel="I understand that deleting my Pebble account will permanently remove all my information, and this action cannot be undone or recovered."
            secondButtonLabel="No, Go Back"
            secondButtonVariant="transparent"
            firstButtonLabel="Delete Account"
            firstButtonVariant="error"
            onFirstButtonClick={handleDeleteAccount}
            onSecondButtonClick={() => { setPopUpModalType(null); setIsModalOpen(false) }}
          />
        );
      case "delete success":
        return (
          <ModalComponent
            icon={<CheckCircleIconSolid className="size-20 text-Success/700" />}
            title="Account has been deleted"
            message="Returning you to login screen."
            firstButtonLabel="Continue"
            onFirstButtonClick={handleReturnToLogin}

          />
        );
      case "delete failure":
        return (
          <ModalComponent
            icon={<img src={alert} alt="alert" className="size-20" />}
            title="Error deleting your account"
            message="Please try again"
            secondButtonLabel="No, Go Back"
            secondButtonVariant="transparent"
            firstButtonLabel="Delete Account"
            firstButtonVariant="error"
            onFirstButtonClick={handleDeleteAccount}
            onSecondButtonClick={() => { setPopUpModalType(null); setIsModalOpen(false) }}
          />
        );
      case "forgot password":
        return (
          <ModalComponent
            icon={<img src={alert} alt="alert" className="size-20" />}
            title="Discard Changes?"
            message="If you cancel now, any unsaved changes to your profile will be discarded."
            secondButtonLabel="Go Back"
            secondButtonVariant="transparent"
            firstButtonLabel="Discard Changes"
            onFirstButtonClick={() => { setPopUpModalType(null); setIsModalOpen(false) }}
            onSecondButtonClick={() => { setPopUpModalType(null); setIsModalOpen(false) }}
          />
        );
      case "forgot success":
        return (
          <ModalComponent
            icon={<CheckCircleIconSolid className="size-20 text-Success/700" />}
            title="Changes have been saved"
            firstButtonLabel="Continue"
            onFirstButtonClick={() => { setPopUpModalType(null); setIsModalOpen(false); }}

          />
        );
      default:
        return <ModalLoadingState />;
    }
  };
  return (
    <>
      <PopUpModal
        open={isModalOpen}
        handleClose={() => setIsModalOpen(false)}
        popUpModalType={popUpModalType}
      >
        {!isLoading ? renderModal() : <ModalLoadingState />}
      </PopUpModal>
      <ForgotPasswordModal
        isOpen={isForgotPasswordModalOpen}
        onClose={closeForgotPasswordModal}
        email={email}
      />
      <div className=" flex flex-col items-start justify-start p-2.5 box-border gap-4 text-sm">
        <div className="self-stretch flex flex-col items-start justify-start gap-4">
          <div className="relative text-lg leading-7 font-medium text-[#344054]">
            Change Password
          </div>
          {userSignInMethod === "Google" && <div className="text-red-500 text-xs mt-1">
            You cannot change the password because you signed in with Google.
          </div>}
          <form onSubmit={handleChangePassword}>
            <div className="mb-2">
              <label className="block text-xs w-full text-grey-900 font-medium">
                Current Password
              </label>
              <input
                type="password"
                value={currentPassword}
                onChange={(e) => setCurrentPassword(e.target.value)}
                className={`w-full p-3 border max-h-[48px] text-grey-700 font-normal placeholder-grey-500 bg-grey-25 border-[1px] border-grey-300 rounded-lg ${isGoogleSignIn ? "opacity-50 cursor-not-allowed" : ""
                  }`}
                placeholder="Enter current password"
                disabled={isGoogleSignIn}
              />
            </div>
            <div className="mb-2">
              <label className="block text-xs text-grey-900 font-medium">
                New Password
              </label>
              <input
                type="password"
                value={newPassword}
                onChange={(e) => setNewPassword(e.target.value)}
                className={`w-full p-3 border max-h-[48px] text-grey-700 font-normal placeholder-grey-500 bg-grey-25 border-[1px] border-grey-300 rounded-lg ${isGoogleSignIn ? "opacity-50 cursor-not-allowed" : ""
                  }`}
                placeholder="Enter new password"
                disabled={isGoogleSignIn}
              />
            </div>
            <div className="mb-2">
              <label className="block text-xs text-grey-900 font-medium">
                Confirm New Password
              </label>
              <input
                type="password"
                value={confirmNewPassword}
                onChange={(e) => setConfirmNewPassword(e.target.value)}
                className={`w-full p-3 border max-h-[48px] text-grey-700 font-normal placeholder-grey-500 bg-grey-25 border-[1px] border-grey-300 rounded-lg ${isGoogleSignIn ? "opacity-50 cursor-not-allowed" : ""
                  }`}
                placeholder="Confirm new password"
                disabled={isGoogleSignIn}
              />
            </div>
            {error && <div className="text-red-500 mt-2">{error}</div>}
            {success && <div className="text-green-500 mt-2">{success}</div>}
            <button
              type="submit"
              className={`mt-4 shadow-[0px_1px_2px_rgba(16,_24,_40,_0.05)] rounded-lg bg-[#344054] flex flex-row items-center justify-center py-3 px-4 text-base text-[#fcfcfd] ${isGoogleSignIn ? "opacity-50 cursor-not-allowed" : ""
                }`}
              disabled={isGoogleSignIn}
            >
              Change Password
            </button>
          </form>
        </div>
      </div>
      <div
        className={`rounded-lg overflow-hidden flex flex-row items-center justify-center py-3 px-4 cursor-pointer text-base text-[#1d64d7]${isGoogleSignIn ? "opacity-50" : ""}`}
        onClick={openForgotPasswordModal}
      >
        <div className="relative underline leading-6 capitalize font-semibold">
          Forgot password?
        </div>
      </div>
      <div className="flex flex-col items-start justify-start p-2.5 box-border"></div>

      <div className="self-stretch px-4 flex flex-col items-start justify-start gap-2">
        <div className="text-lg font-medium leading-[28px]">
          Delete Account
        </div>
      </div>
      <div className="px-3">
        <Button variant="error" onClick={handleDeleteClick} >
          Delete Account
        </Button>
      </div>
    </>
  )
}

export default AccountSettingsContent
